import React, { useEffect } from 'react';
import { Checkbox } from '../../areas/app/Checkbox';
import { VirtualAppsServerRowActions, VirtualAppsServerRowActionsProps } from './VirtualAppsServerRowActions';
import { ApplicationLastDiscoveredTimestamp } from '../ApplicationServerManagement/ApplicationLastDiscoveredTimestamp';

export interface VirtualAppsServerRowProps extends VirtualAppsServerRowActionsProps {
    selected: boolean;
    selectionChangedCallback: Function;
}

export function VirtualAppsServerRow(props: VirtualAppsServerRowProps) {
    const [selected, setSelected]: [any, Function] = React.useState(false);

    const serverApp = props.serverApp;

    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);

    return (
        <tr>
            <td>
                <Checkbox selected={selected} selectionChangedCallback={(checked: boolean) => props.selectionChangedCallback(checked, serverApp.serverName)} />
            </td>
            <td className="details-link">
                <ApplicationLastDiscoveredTimestamp serverApp={serverApp} />
            </td>
            <td>{serverApp.environment}</td>
            <VirtualAppsServerRowActions {...props}></VirtualAppsServerRowActions>
        </tr>
    );
}
